const AccordionToggle = require('./accordion-toggle/script.js');
const BottomGoopButton = require('./bottom-goop/script.js');
const LeftGoopButton = require('./left-goop/script.js');
const ReadMoreGoop = require('./read-more-goop/script.js');
const CirclePlus = require('./circle-plus/script.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-accordion-toggle]', function() {
		new AccordionToggle(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-bottom-goop]', function() {
		new BottomGoopButton(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-left-goop-button]', function() {
		new LeftGoopButton(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-read-more-goop]', function() {
		new ReadMoreGoop(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-circle-plus]', function() {
		new CirclePlus(this, {});
	});
});
